var indentation_default = {
  "indentZero": "yYVS1",
  "indentOne": "cznv-",
  "indentTwo": "gyOn3",
  "indentThree": "_4jjK-",
  "indentFour": "xSkrD",
  "indentFive": "VeoiP",
  "indentSix": "Li7IQ"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
